// extracted by mini-css-extract-plugin
export default {"root":"GeneralConfigContainer-root-6046ad4ade2dcdefb52043f9df819070"};